const iconSize = [16, null, 18];

const textSize = [14, null, 16];

const textSizeSm = [12, null, 14];

const checkBoxTextMt = ["-2px", null, "-2px"];

export { iconSize, textSize, checkBoxTextMt, textSizeSm };
